 
 <form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <nz-form-item *ngIf="!field.hide && !hide" [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label  *ngIf="!field.noLabel" [nzFor]="fieldNew" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>
            <nz-select nzShowSearch nzAllowClear  [formControlName]="fieldNew" [nzPlaceHolder]="field.placeholder|translateTA"  [nzSize]="field.size == null? 'default': field.size" [nzDisabled]="field.isDisabled">>
                <nz-option [nzLabel]="field.showKey?option['VALUE']+' - '+option['LABEL'] : option['LABEL']" [nzValue]="option['VALUE']" *ngFor="let option of dynamicList|async"></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>
</form>
